import { TypeAppleRiverflowFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import AppleRiverflow from './AppleRiverflow'

const ContentfulRiverflow = withContentful<TypeAppleRiverflowFields>(AppleRiverflow)

export default ContentfulRiverflow
